import React from 'react';

import { HoverableLink, Link, Wrapper as ButtonWrapper, withBlockTypeConfigPropsV2, withTokenParsing } from '../common/Button.jsx';
import Layout from '../common/Layout.jsx';
import Token from '../common/Token.jsx';
import Url from '../common/Url.jsx';
import Utilities from '../common/Utilities.jsx';

function _InventoryArtistProfileButtonComponent(props) {
    if (!props.builder && props.content != undefined && props.content.length == 0) {
        return null;
    }
    let ButtonComponent = Link;
    if (props.hoverProps != undefined && props.hoverProps.design) {
        ButtonComponent = HoverableLink;
    }
    const style = {}
    Utilities.copyObject(props.style, style);
    if (props.builder || props.disabled) {
        style.pointerEvents = 'none';
    }
    let className = 'btn btn--whitelabel btn--cta btn--custom2 richText';
    if (props.className) {
        className += ` ${props.className}`;
    }
    let href;
    if (props.data && props.data.artistId) {
        href = Url.getLink('', `artist/${props.data.artistId}`, { sub: props.querySub, layout: props.queryLayout, dataSub: props.queryDataSub }, props.builder);
    }
    return (
        <ButtonWrapper {...props}>
            <ButtonComponent
                className={className}
                design={props.design || Layout.wrapTextForEditor({ text: '' })}
                hoverProps={props.hoverProps}
                href={href}
                style={style}
                type="button" />
        </ButtonWrapper>
    )
}
const InventoryArtistProfileButtonV1Component =
        withTokenParsing(
            withBlockTypeConfigPropsV2(_InventoryArtistProfileButtonComponent),
            (data, keyword) => {
                switch (keyword) {
                    case Token.ArtistName:
                        return data.name;
                }
            });
const InventoryArtistProfileButtonV2Component =
        withTokenParsing(
            withBlockTypeConfigPropsV2(_InventoryArtistProfileButtonComponent, undefined, true),
            (data, keyword) => {
                switch (keyword) {
                    case Token.ArtistName:
                        return data.name;
                }
            });
const InventoryArtistProfileButtonTokens = () => {
    return [
        { display: 'Artist Name', token: Token.ArtistName }
    ];
}
export default { V1: InventoryArtistProfileButtonV1Component, V2: InventoryArtistProfileButtonV2Component, Tokens: InventoryArtistProfileButtonTokens };